// Ticket Entry Page Component. Entry point for ticket data input.
import React from 'react';
import styles from '../css/ticketEntry.module.css';
import { FaSearch } from 'react-icons/fa';
import { useEffect } from 'react';

export default function TicketEntryPage({
  tkt,
  tktRef,
  inputChange,
  locator,
  locatorRef,
  locatorChange,
  pullLocator,
  pullTicket,
  clearInput,
}) {
  // const tktInputRef = useRef(null);
  // const locatorInputRef = useRef(null);

  useEffect(() => {
    if (tktRef.current) {
      tktRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.groupsContainer}>
      <label className={styles.label} htmlFor="ticket">
        PARCS Ticket:
      </label>
      <input
        ref={tktRef}
        name="ticket"
        id="ticket"
        type="number"
        placeholder="PARCS ticket number"
        value={tkt || ''}
        onChange={(e) => {
          inputChange(e);
        }}
        onBlur={() => {
          if (tkt > 0) {
            pullTicket();
            clearInput();
          }
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            pullTicket();
            clearInput();
            // locatorRef.current.focus();
          }
        }}
        required
        className={styles.ticketInput}
      />
      <label className={styles.label} htmlFor="locTicket">
        Locator Ticket:
      </label>
      <input
        ref={locatorRef}
        name="locTicket"
        autoFocus
        id="locTicket"
        type="number"
        placeholder="Locator ticket number"
        value={locator || ''}
        onChange={(e) => {
          locatorChange(e);
        }}
        onBlur={() => {
          pullLocator();
          clearInput();
        }}
        // onFocus={() => {
        //   locatorInputRef.current.select();
        //   // locatorInputRef.current.value = '';
        // }}
        required
        className={styles.ticketInput}
      />
      <button
        type="button"
        className={styles.findTicketBtn}
        onClick={() => {
          pullTicket();
        }}
      >
        <FaSearch
          style={{
            marginRight: '8px',
            position: 'relative',
            top: '2px',
          }}
        />
        Find Ticket
      </button>
    </div>
  );
}
